export interface ServiceRequest {
  id: string;
  user_id: string;
  service_id: string;
  customer_name: string;
  customer_email: string | null;
  customer_phone: string | null;
  status: 'pending' | 'accepted' | 'rejected' | 'completed' | 'cancelled';
  notes: string | null;
  location: string | null;
  scheduled_at: string | null;
  created_at: string;
  paid: boolean;
  cancellation_reason?: string;
  services: {
    id: string;
    name: string;
    price: number;
    duration?: number;
    duration_unit?: string;
    instant_booking?: boolean;
    currency?: string;
    requires_scheduling?: boolean;
  };
  customer_page_link?: string;
}

// Add the mapToServiceRequest function to transform database records into ServiceRequest objects
export function mapToServiceRequest(record: any): ServiceRequest {
  return {
    id: record.id,
    user_id: record.user_id,
    service_id: record.service_id,
    customer_name: record.customer_name,
    customer_email: record.customer_email,
    customer_phone: record.customer_phone,
    status: record.status,
    notes: record.notes,
    location: record.location,
    scheduled_at: record.scheduled_at,
    created_at: record.created_at,
    paid: record.paid || false,
    cancellation_reason: record.cancellation_reason,
    services: {
      id: record.services?.id || '',
      name: record.services?.name || '',
      price: record.services?.price || 0,
      duration: record.services?.duration,
      duration_unit: record.services?.duration_unit,
      instant_booking: record.services?.instant_booking,
      requires_scheduling: record.services?.requires_scheduling,
    },
    customer_page_link: record.customer_page_link
  };
}
